// app/javascript/pages/index.js

const videos = [
    {
        id: 1,
        title: "Benefits of a convertible wind deflector. Wind deflectors reduce wind and noise by up to 75%",
        videoSrc: "https://www.youtube.com/embed/aPoUDqXqmKo?rel=0", // Note: These are placeholder URLs
        thumbnail: "https://img.youtube.com/vi/aPoUDqXqmKo/mqdefault.jpg"
    },
    {
        id: 2,
        title: "15 Questions about Wind Deflectors for convertible cars designed and manufactured by Love The Drive",
        videoSrc: "https://www.youtube.com/embed/xjKBS2K9uUI?rel=0",
        thumbnail: "https://img.youtube.com/vi/xjKBS2K9uUI/mqdefault.jpg"
    },
    {
        id: 3,
        title: "Love The Drive is the largest North American manufacturer of wind deflectors for convertible cars.",
        videoSrc: "https://www.youtube.com/embed/qQSRyGhUgn8?rel=0",
        thumbnail: "https://img.youtube.com/vi/qQSRyGhUgn8/mqdefault.jpg"
    },
    {
        id: 4,
        title: "What is the difference between Regular Wind Deflectors & Lightbar Wind Deflectors by Love The Drive",
        videoSrc: "https://www.youtube.com/embed/aMRkIya5m0c?rel=0",
        thumbnail: "https://img.youtube.com/vi/aMRkIya5m0c/mqdefault.jpg"
    }
];

let currentVideoId = 1; // Default to the first video

// Helper functions to get DOM elements (ensures they are fresh on each call if needed)
function getMainVideoElement() { return document.getElementById('mainVideo'); }
function getMainVideoContainerElement() { return document.getElementById('mainVideoContainer'); }
function getThumbnailGridElement() { return document.getElementById('thumbnailGrid'); }

function loadVideo(videoId, skipAnimation = false) {
    const video = videos.find(v => v.id === videoId);
    if (!video) {
        console.error(`Video with ID ${videoId} not found.`);
        return;
    }

    const mainVideo = getMainVideoElement();
    const mainVideoContainer = getMainVideoContainerElement();

    if (!mainVideo || !mainVideoContainer) {
        console.error('Main video player or its container element not found in the DOM. Cannot load video.');
        return;
    }

    if (!skipAnimation) {
        mainVideoContainer.classList.add('loading');
    }

    // Simulate loading delay for smooth transition (as in original code)
    // The videoSrc URLs are placeholders. For actual YouTube videos, 
    // you'd use an embed URL like "https://www.youtube.com/embed/VIDEO_ID"
    // and mainVideo would typically be an <iframe>.
    setTimeout(() => {
        mainVideo.src = video.videoSrc;
        currentVideoId = videoId;
        
        updateThumbnailStates();
        
        if (!skipAnimation) {
            mainVideoContainer.classList.remove('loading');
        }
    }, skipAnimation ? 0 : 800);
}

function createThumbnailElement(video) {
    const isActive = video.id === currentVideoId;
    // onclick attribute is removed; event listeners will be added programmatically.
    return `
        <div class="thumbnail-item ${isActive ? 'active' : ''}" data-video-id="${video.id}">
            <div class="position-relative">
                <img src="${video.thumbnail}" alt="${video.title}" class="thumbnail-image">
                <div class="play-overlay">
                    <i class="fas fa-play"></i>
                </div>
                <div class="active-indicator">
                    <i class="fas fa-check"></i>
                </div>
            </div>
            <div class="thumbnail-content">
                <h4 class="thumbnail-title">${video.title}</h4>
            </div>
        </div>
    `;
}

function updateThumbnailStates() {
    const thumbnailItems = document.querySelectorAll('#thumbnailGrid .thumbnail-item');
    thumbnailItems.forEach(item => {
        const videoId = parseInt(item.dataset.videoId);
        if (videoId === currentVideoId) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    });
}

function addThumbnailEventListeners() {
    const thumbnailGrid = getThumbnailGridElement();
    if (!thumbnailGrid) return;

    // Use event delegation on the grid for dynamically added items, or just query all items.
    // For simplicity here, query all after creation.
    const thumbnailItems = thumbnailGrid.querySelectorAll('.thumbnail-item');
    thumbnailItems.forEach(item => {
        item.addEventListener('click', () => {
            const videoId = parseInt(item.dataset.videoId);
            loadVideo(videoId); // Pass false for skipAnimation, or handle as needed

            // Smooth scroll behavior (ensure the target element exists)
            const mainVideoContainerToScroll = document.querySelector('.main-video-container') || getMainVideoContainerElement();
            if (mainVideoContainerToScroll) {
                setTimeout(() => { // Small delay can sometimes help ensure layout is ready
                    mainVideoContainerToScroll.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center' // Or 'start' based on your layout preference
                    });
                }, 100);
            }
        });
    });
}

function initializeVideoShowcase() {
    const thumbnailGrid = getThumbnailGridElement();
    
    if (!thumbnailGrid) {
        console.error('Thumbnail grid element (#thumbnailGrid) not found. Video showcase cannot be initialized.');
        return;
    }
    
    // Create and inject thumbnail HTML
    thumbnailGrid.innerHTML = videos.map(createThumbnailElement).join('');
    
    // Add event listeners to the newly created thumbnails
    addThumbnailEventListeners();
    
    // Load the default first video
    const initialVideo = videos.find(v => v.id === currentVideoId) || (videos.length > 0 ? videos[0] : null);
    if (initialVideo) {
        loadVideo(initialVideo.id, true); // skipAnimation = true for initial load
    } else {
        console.error('No initial video found to load.');
    }
}

// This is the function that will be exported and called by your `application.js`
export default function initVideoShowcaseModule() {
    // The core initialization logic for the video showcase.
    // This function is called after the main page's `turbo:load` has fired
    // and the check for your page-specific container (e.g., #videoShowcaseContainer) has passed.
    initializeVideoShowcase();
    
    // The original global click listener for smooth scroll is now integrated
    // into addThumbnailEventListeners for more specific behavior.
}